export default __webpack_public_path__ + "static/media/probsolving_whitecard.0b69d102.svg";